exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inquiry-table[data-v-5ad56ff6]{margin-top:16px}.pagination[data-v-5ad56ff6]{margin-top:5px;text-align:right}[data-v-5ad56ff6] .el-table__body td{padding:8px 5px !important;height:40px !important}\n", ""]);

// exports
